import React from 'react';
import Inc from './Include';
import './Talk.scss';

function End ({history,face,goResult}){
    const face_class = "fas fa-" + Inc.FACE_ICON[ face-1 ]+" face";
    const last = history.length;
	return (
    <div id="talk">
        <div className="inner">
            <div className="reply">
                <i className="fas fa-user-astronaut face"></i>
                {history[last-4]}
            </div>
            <div className="talk">
                <i className={face_class}></i>
                {history[last-3]}
            </div>
            <div className="reply">
                <i className="fas fa-user-astronaut face"></i>
                {history[last-2]}
            </div>
            <div className="talk">
                <i className={face_class}></i>
                {history[last-1]}
            </div>
        </div>
        <div className="end">
            <p>Good Job!!</p>
            <button
                onClick={goResult}
            >ログを見る</button>
        </div>
    </div>
    );
}

export default End;
